import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FirstLetterPipe, ToggleDirective, ScrollTopDirective, StickyDirective, LineBreakPipe } from './_base/layout/index';
import { OffcanvasDirective } from './_base/layout/directives/offcanvas.directive';
import { MenuDirective } from './_base/layout/directives/menu.directive';
import { ContentAnimateDirective } from './_base/layout/directives/content-animate.directive';

@NgModule({
	imports: [CommonModule],
	declarations: [ToggleDirective, OffcanvasDirective, MenuDirective, ContentAnimateDirective, StickyDirective, ScrollTopDirective, FirstLetterPipe, LineBreakPipe],
	exports: [ToggleDirective, OffcanvasDirective, MenuDirective, ContentAnimateDirective, StickyDirective, ScrollTopDirective, FirstLetterPipe, LineBreakPipe],
	providers: [],
})
export class CoreModule {}
